import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useGeoState, useGeoFetch } from '../../components/GeoProvider'
import ErrorMessage from '../../components/Layout/ErrorMessage'
import Spinner from '../../components/Loader/Spinner'
import EmptyMap from '../../components/Map/emptyMap'
import Map from '../../components/Map'
import Timeline from '../../components/Timeline'
import toolTipFormatter from './toolTipFormatter'
import BTMapLegend from './birthtrendMapLegendHorizontal'
import SideTable from './SideTable'
import styles from './MapPage.module.scss'
import dayjs from 'dayjs'
import DisplayDateProvider from '../../components/DisplayDateProvider/DisplayDateProvider'
const DashboardMap = ({ zoomLocation }) => {  
  let getCategoryState=window.localStorage.getItem('bt_category')
  const chartRef = useRef(null)
  const location = useLocation()
  const hash = location.hash
  const slotTimeInSeconds = 604800000
  const latestPositionString = ''
  const slotString = 'week'
  const [getMapStates, setMapStates] = useState()
  const [metros, setMetros] = useState()
  const [getStats, setStats] = useState()
  const [getMSAStats, setMSAStats] = useState()
  const [errorCode, setErrorCode] = useState()
  const [errorMessage, setErrorMessage] = useState()
  const [errorSubject, setErrorSubject] = useState()
  const [errorOccured, seterrorOccured] = useState(false)
  const [getStateJson, setStateJson] = useState()
  const [getCBSAJsonData, setCBSAJsonData] = useState()
  const [activeCbsa, setActiveCbsa] = useState()
    const [isLoading,setIsLoading] =useState(false)
  const {
    dataStartDate,
    dataEndDate,
    mapOptions,
    regionSelected,
    setRegionSelected,
    displayDate,
    setDisplayDate,
    getComorbState,
    getAgeState,
    getTrimesterState
  } = useGeoState()

  if (hash) {
    if (hash.split('-').length > 1) {
      setRegionSelected(hash.split('-')[0].replace('#', ''))
    }
  }

useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getdashmap`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            geo_type:'STATE',
            trimester_ids:getCategoryState==="2"?'NA':getTrimesterState.value,
            age_group_ids:getAgeState.value,
            comorb_ids:getComorbState.map(item => item.value).sort().join(','),
            category_ids:getCategoryState
            
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
              if(Object.keys(resData.data.results).length===0)
                {
                  setMapStates(null)
                  setStats(null)
                   setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
                }
                else
                {
                seterrorOccured(false)
                var datacount= Object.keys(resData.data.results).length-1 
                let dd=Object.values(resData.data.results)[datacount]
                let mappedStateData =  Object.entries(dd).map((state) => {
                    let stateName = state[1].geo_name
                    return { ...state[1], name: stateName, identifier: stateName }
                     })
                setDisplayDate(Object.keys(resData.data.results).sort()[datacount]) 
                setStats(mappedStateData)
                setMapStates(resData.data.results)
                }
            }
            else{
                setMapStates(null)
                setStats(null)
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
        }).catch((err) => {
            seterrorOccured(true)
          })},[1,getAgeState,getTrimesterState,getComorbState,getCategoryState])


useEffect(() => {
  setIsLoading(true)
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getdashmap`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            geo_type:'FIPS',
            trimester_ids:getCategoryState==="2"?'NA':getTrimesterState.value,
            age_group_ids:getAgeState.value,
            comorb_ids:getComorbState.map(item => item.value).sort().join(','),
            category_ids:getCategoryState
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          seterrorOccured(false)
          setIsLoading(false)
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
                if(Object.keys(resData.data.results).length===0)
                {
                  setMapStates(null)
                  setStats(null)
                   setErrorCode(resData.status)
                  setErrorMessage(resData.message)
                  setErrorSubject(resData.subject)
                  seterrorOccured(true)
                }
                else
                {
                   
                  var datacount= Object.keys(resData.data.results).length-1 
                  let dd= Object.values(resData.data.results)[datacount]
                    let mappedMSAData = Object.entries(dd).map((state) => {
                    let name = state[1].geo_name
                    return { ...state[1], name: name, identifier: name }
                     })
                  setMSAStats(mappedMSAData) 
                  setMetros(resData.data.results)
                  seterrorOccured(false)
                }
            }
            else{
              setStats(null)
                setMapStates(null)
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
          
        }).catch((err) => {
          setIsLoading(false)
            seterrorOccured(true)
          })},[1,getAgeState,getTrimesterState,getComorbState,getCategoryState])


useEffect(() => {
    fetch(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/birthtrend/getactivelocations`,
        {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            requester: JSON.stringify(window.localStorage.getItem('requester')),
          },
          body: JSON.stringify({
            geo_type:'COUNTY',
            geo_parent:'US'
          }),
          withCredentials: true,
          credentials: 'include',
        }
      )
        .then((response) => response.json())
        .then((resData)=>{
          seterrorOccured(false)
          if (resData !== null && resData !== undefined) {
            if (resData.status === 200) {
                setActiveCbsa(resData.data)
                seterrorOccured(false)
            }
            else{
                setErrorCode(resData.status)
                setErrorMessage(resData.message)
                setErrorSubject(resData.subject)
                seterrorOccured(true)
            }
           
          }
        }).catch((err) => {
            seterrorOccured(true)
          })},[1])
    
  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/usStatesAll.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setStateJson(data)
      })
      .catch(function (err) {
        console.log(err, ' error file usStatesAll.json')
      })
  }, [1])
  useEffect(() => {
    let url = `${window.location.origin}/birthtrend/county.json`
    fetch(url)
      .then(function (res) {
        return res.json()
      })
      .then(function (data) {
        setCBSAJsonData(data)
      })
      .catch(function (err) {
        console.log(err, ' error file us_hrr_values ')
      })
  }, [1])

  if ( errorOccured) {
    return (
      <ErrorMessage
        errorCode={errorCode}
        errorMessage={errorMessage}
        errorSubject={errorSubject}
        errorDetails={errorMessage}
      />
    )
  }
  return (
    <div className={`${styles.base}`}>
      <div className={`${styles.cbsasPanel}`}>
        <>
          {regionSelected === 'state' && (
            <>
              {getStats !== undefined ? (
                <SideTable stateData={getStats} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
           {regionSelected === 'fips'&&  (
            <>
              {getMSAStats !== undefined  && isLoading!==true  ? (
               
                <SideTable stateData={getMSAStats} chartRef={chartRef} />
              ) : (
                <div style={{ border: '1.5px solid #CBCCCD', height: '84vh' }}>
                  <Spinner />
                </div>
              )}
            </>
          )}
        </>
      </div>
      <div className={`${styles.map}`}>
        {regionSelected === 'state' && (
          <>
            {getMapStates !== undefined && getStateJson ? (
              <>
                <div className={`${styles.providerHeader}`}>
               <DisplayDateProvider
                textShow={'Insights for '}
                        showWeek={false}
                        lastweekEndDate={displayDate}
                        dashType={'BIRTHTREND'}
                      />
                      <Timeline
                      statesData={getMapStates}
                      latestPositionString={latestPositionString}
                      slotString={slotString}
                      slotTimeInSeconds={slotTimeInSeconds}
                      markCounts={12}
                    //   loadError={stateDataError}
                      dashboardType={'BIRTHTREND'}
                  />
                  
               </div>
              
               <div className={styles.legendDiv}>
                <BTMapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={null}
                  statesData={getMapStates}
                  cbsaData={null}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="countymap"
                  enableButtons={true}
                  chartRef={chartRef}
                  mapDataType={0}
                  stateJson={getStateJson}
                  dashboardType="birthtrend"
                />

               
              </>
            ) : (
             
              <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
         {regionSelected === 'fips' &&(
          <>
            {metros !== undefined && 
            getCBSAJsonData!==undefined && 
            activeCbsa!==undefined  && isLoading!==true ? (
              <>
                <div className={`${styles.providerHeader}`}>
               <DisplayDateProvider
                textShow={'Insights for '}
                showWeek={false}
                lastweekEndDate={displayDate}
                dashType={'BIRTHTREND'}
                      />
                      <Timeline
                    statesData={getMapStates}
                    latestPositionString={latestPositionString}
                    slotString={slotString}
                    slotTimeInSeconds={slotTimeInSeconds}
                     markCounts={12}
                    // loadError={stateDataError}
                    dashboardType={'BIRTHTREND'}
                  />
                  
               </div>
              
               <div className={styles.legendDiv}>
                <BTMapLegend />
                </div>
                <Map
                  toolTipFormatter={toolTipFormatter}
                  activeCbsasData={activeCbsa}
                  statesData={getMapStates}
                  cbsaData={null}
                  countyData={metros}
                  mapOptions={mapOptions}
                  dynamicMapTitle={true}
                  mapType="countymapmsa"
                  enableButtons={true}
                  zoomLocation={zoomLocation}
                  chartRef={chartRef}
                  mapDataType={1}
                  countyGeoJson={getCBSAJsonData}
                  stateJson={getStateJson}
                  dashboardType="birthtrend"
                  showCountyLabels={true}
                />

               
              </>
            ) : (
             
               <EmptyMap stateJson={getStateJson} />
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default DashboardMap
